export default __webpack_public_path__ + "static/media/img6.bd35a9b7.png";